module.exports = __webpack_public_path__ + "img/zwischenzeiten8.68b86016.jpg";